export default __webpack_public_path__ + "static/automate-dont-1-dark-517b125b39396e31c7e700519414aa7b.png";